<template>
<div class="suspension" :style="{ right, bottom }" @click="share">
  <img v-if="!Object.is(img, 'false')" :src="img"/>
  <span class="desc" :style="{ 'padding': Object.is(img, 'false') ? '8px' : 0 }">{{desc}}</span>
</div>
</template>
<script>
export default {
  props: {
    right: {
      type: String,
      default: '16px'
    },
    bottom: {
      type: String,
      default: '96px'
    },
    desc: {
      type: String,
      default: '分享'
    },
    img: {
      type: String,
      default: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E6%82%AC%E6%B5%AE%E5%88%86%E4%BA%AB.svg'
    }
  },
  methods: {
    share () {
      this.$emit('share')
    }
  }
}
</script>
<style lang="scss" scoped>
.suspension {
  position: fixed;
  width:44px;
  box-sizing: border-box;
  height:44px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 12px 0px rgba(0,0,0,0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 999;
  img {
    width: 18px;
    height: 18px;
  }
  .desc {
    font-size:9px;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight: bold;
    color:rgba(0,0,0,1);
    line-height:13px;
    display: block;
    letter-spacing: 0.45px;
    text-align: center;
  }
}
</style>
